import{get,post}    from    './index.js'

export  const   appGetArticleDetailApi      =  params   =>  get("/app/article",params)              //获取文章详情
export  const   AppGetRnethouseDetailApi    =   params   =>  get("/app/rentHouse",params)           //微信分享h5页,获取租房详情
export  const   AppGetSellhouseDetailApi    =   params   =>  get("/app/sellHouse",params)           //获取出售房源详情

export  const   appOpenOpenAppUrlApi        =   data    =>  post("/app/openOpenAppUrl",data)        //保存访问/openApp时的记录

export  const   appOpenHomePageApi          =   data    =>  post("/app/openHomePage",data)          //首页访问